export const FETCH_REQUEST_WITH_TYPES = 'FETCH_REQUEST_WITH_TYPES';

// Creates an action which is interpreted by /middleware/fetch.js.
// The fetch middleware is passed action types and promises
// to dispatch them when the request is made.
export const fetchRequestWithTypes = (action) => {
	return {
		type: FETCH_REQUEST_WITH_TYPES,
		...action,
	};
};

export * from './account';
export * from './accountVerification';
export * from './advisoryAgreement';
export * from './auth';
export * from './autoStash';
export * from './bankAccount';
export * from './bookmarks';
export * from './card';
export * from './clearing';
export * from './drip';
export * from './emailVerification';
export * from './enrollments';
export * from './harmonyBank';
export * from './fundingSource';
export * from './investorApplication';
export * from './investments';
export * from './iraDistributions';
export * from './onboarding';
export * from './moneyMovements';
export * from './platformTiers';
export * from './quotes';
export * from './referrals';
export * from './search';
export * from './securitiesLending';
export * from './statusMessages';
export * from './subscriptions';
export * from './transactions';
export * from './trustedContact';
export * from './user';
export * from './updateIncome';
export * from './buySources';
export * from './idempotencyKey';
export * from './pxQuestions';
export * from './rollovers';
export * from './stockParty';
